import React from "react";
import config from "../../app/config";
import { VWQIcon } from "@sunwing/icons";

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("./helpfulinfoVwq.module.scss");
  } else {
    styles = await import("./helpfulinfo.module.scss");
  }
})();

const QuickLinkGrid = ({ data, handleQuickLink }) => {
  return (
    <>
      {data.map((link, index) => (
        <div className={styles.quickLinkContainer}>
          <button
            className={styles.quickLinkButton}
            onClick={() => handleQuickLink(link)}
          >
            <div className={styles.quickLinkIconWrapper}>
              <VWQIcon name="vacation" className={styles.quickLinkIcon} />
            </div>
            <div className={styles.quickLinkText}>{link.displayTitle}</div>
          </button>
        </div>
      ))}
    </>
  );
};

export default QuickLinkGrid;
